import locale from 'modules/employee/presentation/locale';
import routes from 'modules/employee/presentation/routes';

const employeeModule = {
  locale,
  routes,
};

export default employeeModule;
